<template>
    <div class="register-form">
        <div class="register-form-img">
            <img class="bg-image" src="assets/layout/images/milkyway.png" alt="" />
            <img class="logo-image" src="assets/layout/images/site-logo-WN.svg" alt="Wealth Net">
        </div>
        <div class="register-form-content">
            <div class="register-form-head">
                <h1>Register</h1>
                <div class="login-link">
                    Back to <Button @click="toLogin()" label="Login" />
                </div>
            </div>
            <div class="register-form-body">
                <div class="form-item">
                    <label for="user-name">Username</label>
                    <InputText id="user-name" placeholder="Username" v-model="username" />
                </div>
                <div class="form-item">
                    <label for="first-name">First name</label>
                    <InputText id="first-name" placeholder="First Name" v-model="name" />
                </div>
                <div class="form-item">
                    <label for="last-name">Last name</label>
                    <InputText id="last-name" placeholder="Last Name" v-model="surname" />
                </div>
                <div class="form-item">
                    <label for="email">Email</label>
                    <InputText id="email" placeholder="Email" v-model="email" />
                </div>
                <div class="form-item" v-tooltip.left="'Sponsor username'">
                    <label for="sponsor">Sponsor</label>
                    <InputText id="sponsor" placeholder="Sponsor" v-model="sponsor" :disabled="$route.query.id" />
                </div>
                <div class="form-item">
                    <label for="password">Password</label>
                    <Password placeholder="Password" v-model="password" />
                </div>
                <div class="form-item">
                    <label for="password-confirm">Confirm Password</label>
                    <Password id="password-confirm" placeholder="Confirm Password" v-model="confirmpassword" />
                </div>
                <div class="form-item form-item-no-label">
                    <div>
                        <Checkbox id="tos" value="tos" v-model="tos" :binary="true" :disabled="false" />
                        <span> I agree to the <Button @click="openTos" label="terms of service"></Button></span>
                    </div>
                </div>
                <!-- <div class="form-item form-item-no-label">
                    <Button @click="openTos" label="Terms of Use - Privacy policy"></Button>
                </div> -->
                <div class="form-action">
                    <Button :disabled="!tos" @click="register()" label="Register" style="word-break: break-all;" />
                </div>
            </div>

            <!--<Dialog header="Terms of Service" :visible.sync="dialog.tos" :style="{width: '50vw'}" :modal="true">
                <div>
                    <a :href="pdfUrl ||'#'">
                        <span>Download: {{pdfUrl}}</span>
                    </a>
                    <p>Scroll down to agree</p>
                </div>
                <div>
                    <pdf v-for="i in numPages"
                         :key="i"
                         :page="i"
                         :src="pdfUrl">


                    </pdf>
                </div>
                <template #footer>
                    <div class="p-grid">
                        <div class="p-md-6 p-offset-6">
                            <Button @click="agree()" label="I Agree" style="word-break: break-all;" />
                        </div>
                    </div>
                </template>
            </Dialog>-->
            <Toast />
        </div>
    </div>
</template>

<script>
    import RegisterService from "../service/RegisterService.js";
    import { required, email } from 'vuelidate/lib/validators'
    //import pdf from 'vue-pdf';
    //var loadingTask = pdf.createLoadingTask(process.env.VUE_APP_AUTH_URL + "docs/privacy.pdf");
    //console.log(process.env.VUE_APP_AUTH_URL + "/docs/privacy.pdf");
    export default {
        components: {
          //  pdf
        },
        data() {
            return {
                username: null,
                email: null,
                password: null,
                refid: null,
                confirmpassword: null,
                name: null,
                surname: null,
                sponsor: null,
                tos: false,
                //pdfUrl: process.env.VUE_APP_AUTH_URL + "docs/privacy.pdf",
                dialog: {
                    tos: false
                },
                numPages: 0,
                src: loadingTask,

            };
        },
        validations: {
            username: {
                required,
            },
            email: {
                required,
                email,
            },
            name: {
                required,
            },
            surname: {
                required,
            },
        },
        async created() {
            this.registerService = new RegisterService();
            this.refid = this.$route.query.id;
            if (this.refid) {
                this.sponsor = await this.registerService.getSponsor(this.refid);
                console.log(this.refid, this.sponsor);
            }
        },
        mounted() {
            //this.src.promise.then(pdf => {
            //    this.numPages = pdf.numPages;
            //});
        },
        methods: {
            async register() {
                if (this.confirmpassword !== this.password) {
                    this.$toast.add({
                        severity: "error",
                        summary: "Passwords don't match",
                        detail: "Validation failed",
                        life: 3000,
                        position: "topleft"
                    });
                } else if (this.confirmpassword === this.password) {
                    this.refid = this.$route.query.id;
                    console.log(this.refid);
                    console.log("paswordovi");
                    console.log(this.$v.invalid);

                    if (!this.$v.$invalid) {
                        this.$root.disableInterceptor()
                        const resp = await this.registerService.register({
                            username: this.username,
                            name: this.name,
                            surname: this.surname,
                            email: this.email,
                            password: this.password,
                            refid: this.refid,
                            phone: this.phone,
                            address: this.address,
                            zip: this.zip,
                            city: this.city,
                            country: this.country,
                            sponsor: this.sponsor
                        });
                        console.log('status')
                        console.log(resp);
                        if (resp.status == 400) {
                            this.$store.commit('setErrorDialogMsg', resp.data.message);
                            this.$store.commit('openErrorDialog');
                        }
                        if (resp.status == 200) {
                            this.$toast.add({
                                severity: "success",
                                summary: "Registration success!",
                                detail: "redirect to login",
                                life: 3000,
                                position: "topleft"
                            });

                            var self = this;
                            setTimeout(function () {
                                self.$router.push({
                                    name: "login"
                                });
                            }, 2000);
                        }
                    }
                    else {
                        this.$toast.add({
                            severity: "error",
                            summary: "All fields except the sponsor field are required",
                            detail: "Registration attempt failed",
                            life: 3000,
                            position: "topleft"
                        });
                    }
                }
            },
            toLogin() {
                this.$router.push('login');
            },
            openTos() {
                console.log('tos');
                this.dialog.tos = true;

            },
            agree() {
                this.tos = true;
                this.dialog.tos = false;
            }
        }
    };
</script>

<style lang="scss">
    .p-dialog-content {
        overflow-x: hidden;
    }
</style>